import { jsonp } from '@ifeng/ui_base';

const getCoverList = async () => {
    let result = await jsonp('//shankapi.ifeng.com/api/recommend/288387/1/100/getCoverList', {
        jsonpCallback: 'getCoverList',
        cache: false,
    });

    if (result?.data?.length > 0) {
        result = result.data.map(item => ({
            base62Id: item?.base62Id,
            thumbnail: item?.thumbnail || item?.thumbnails?.image?.[0]?.url || '',
            url: item?.url || '',
        }));
    } else {
        result = [];
    }

    return result;
};

export { getCoverList };
